import Vue from 'vue'
import { Avatar,Button,Input,InputNumber,Select,Option,Table,TableColumn,Row,Col,Radio,RadioGroup,Checkbox,CheckboxGroup,MessageBox,DatePicker,Message,Form,FormItem,Tree,Slider,Dialog,Aside,Main,Container,Menu,Submenu,MenuItem,MenuItemGroup,Breadcrumb,BreadcrumbItem,Pagination,Tabs,TabPane,Switch,Autocomplete,Transfer,Loading,Cascader,Collapse,CollapseItem,Upload,Carousel,CarouselItem,Popover,Card,Empty,Dropdown,DropdownItem,DropdownMenu,Tag } from 'element-ui';
Vue.use(Avatar);
Vue.use(Button);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Select);
Vue.use(Option);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Row);
Vue.use(Col);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(DatePicker);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Slider);
Vue.use(Dialog);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Tree);
Vue.use(Container);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Pagination);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Switch);
Vue.use(Autocomplete);
Vue.use(Transfer);
Vue.use(Cascader);
Vue.use(Loading.directive);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Upload);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Popover);
Vue.use(Card);
Vue.use(Empty);
Vue.use(Dropdown);
Vue.use(DropdownItem);
Vue.use(DropdownMenu);
Vue.use(Tag);
Vue.prototype.$loading = Loading.service;
Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;